import { render, staticRenderFns } from "./beneficiarios.vue?vue&type=template&id=1282167f&"
import script from "./beneficiarios.vue?vue&type=script&lang=js&"
export * from "./beneficiarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports